import { Reveal, Chapter } from "./Reveal";

const SHOTS = [
  { img: "/catalog/quarry-aerial.jpg", caption: "Our quarries, Kota", span: "md:col-span-2" },
  { img: "/catalog/paving-hexagon.jpg", caption: "Kota hexagon × basalt cobble driveway", span: "" },
  { img: "/catalog/cobbles-multi.jpg", caption: "Multi-colour cobble pathway", span: "" },
  { img: "/catalog/cladding-blue.jpg", caption: "Kota Blue shot-brush facade", span: "md:col-span-2" },
  { img: "/catalog/cobbles-red.jpg", caption: "Red Mandana cobble walkway", span: "md:col-span-2" },
  { img: "/catalog/paving-herringbone.jpg", caption: "Herringbone paving, multi-colour", span: "" },
  { img: "/catalog/cladding-mint.jpg", caption: "Mint rockface cladding", span: "" },
  { img: "/catalog/exhibition.jpg", caption: "STONA Exhibition, Bangalore", span: "md:col-span-2" },
];

const Gallery = () => (
  <section id="gallery" className="relative bg-ink border-t border-bone/10 px-6 md:px-12 lg:px-20 py-28 md:py-36" data-testid="gallery-section">
    <div className="flex flex-col gap-6 mb-16">
      <Reveal>
        <Chapter index="05" title="In Situ" testid="gallery-chapter" />
      </Reveal>
      <Reveal delay={0.1} className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <h2 className="text-4xl sm:text-5xl font-heading font-bold tracking-tight leading-[1.05]" data-testid="gallery-heading">
          From Kota,{" "}
          <span className="font-editorial italic font-medium text-copper">to timeless spaces.</span>
        </h2>
        <p className="max-w-sm text-sm md:text-base font-light text-bone/60 leading-relaxed">
          Quarry faces, factory floors, finished driveways and exhibition halls —
          our stone, at work.
        </p>
      </Reveal>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
      {SHOTS.map((s, i) => (
        <Reveal key={s.img} delay={(i % 3) * 0.08} className={s.span}>
          <figure className="group relative overflow-hidden bg-stone h-[320px] md:h-[400px]">
            <img
              src={s.img}
              alt={s.caption}
              loading="lazy"
              className="h-full w-full object-cover grayscale-[25%] transition-[transform,filter] duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0"
              data-testid={`gallery-image-${i + 1}`}
            />
            <figcaption className="absolute bottom-4 left-4 text-[10px] tracking-[0.3em] uppercase font-heading text-bone/80 bg-ink/60 backdrop-blur px-3 py-2 opacity-0 translate-y-2 transition-[opacity,transform] duration-500 group-hover:opacity-100 group-hover:translate-y-0">
              {s.caption}
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Gallery;
